function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
// type Fetch = (url: string, options: ?any) => Promise<any>;
//
// type Options = {
//   baseUrl: string,
//   cookie?: string,
// };
/**
 * Creates a wrapper function around the HTML5 Fetch API that provides
 * default arguments to fetch(...) and is intended to reduce the amount
 * of boilerplate code in the application.
 * https://developer.mozilla.org/docs/Web/API/Fetch_API/Using_Fetch
 */ function createFetch(fetch, { baseUrl, token }) {
    // NOTE: Tweak the default options to suite your application needs
    const defaults = {
        method: 'GET',
        mode: baseUrl ? 'cors' : 'same-origin',
        // credentials: baseUrl ? 'include' : 'same-origin',
        headers: _object_spread({
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }, token ? {
            Authorization: `Bearer ${token}`
        } : null)
    };
    return async (url /* : string */ , options /* : any */ )=>{
        if (options && options.body) {
            options.body = JSON.stringify(options.body);
        }
        if (url.startsWith('/api')) {
            return fetch(`${baseUrl}${url}`, _object_spread_props(_object_spread({}, defaults, options), {
                headers: _object_spread({}, defaults.headers, options && options.headers)
            }));
        }
        if (url.startsWith('http://localhost:12345')) {
            return fetch(url, _object_spread_props(_object_spread({}, options), {
                headers: _object_spread({
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }, options && options.headers)
            }));
        }
        return fetch(url, options);
    };
}
export default createFetch;
